import { GoReport } from "react-icons/go";
import { FaCarAlt, FaDollarSign, FaPlayCircle, FaStore, FaTools } from "react-icons/fa";
import { FaCarOn, FaUser, FaUserGroup } from "react-icons/fa6";
import { IoAnalyticsOutline, IoCameraOutline, IoCloudDownloadOutline, IoNotificationsOutline, IoSettingsOutline, IoShareSocialOutline } from "react-icons/io5";
import { RxDashboard } from "react-icons/rx";
import { Paths } from "../router/Paths";
import { FaMessage } from "react-icons/fa6";
import { TbReport } from "react-icons/tb";

export type SidebarTabsType =
  | "Dashboard"
  | "Cars"
  | "Users"
  | "Messages"
  | "Reports"
  | "Staff"
  | "Money Request"
  | "Car Request"
  | "Spare Parts"
  | "Short Videos"
  | "Notifications"
  | "App Update"
  | "Dealer Market"
  | "Quick Capture"
  | "Import Cars"
  | "Valuations"
  | "Distribution";

type IconComponentType = React.ComponentType<{ size?: number; color?: string }>;

export interface SideBarTabInterface {
  name: SidebarTabsType;
  icon: IconComponentType;
  path: string;
}

interface SidebarTabsInterface {
  Overview: SideBarTabInterface;
  Cars: SideBarTabInterface;
  Users: SideBarTabInterface;
  Messages: SideBarTabInterface;
  Reports: SideBarTabInterface;
  Staff: SideBarTabInterface;
  MoneyRequest: SideBarTabInterface;
  CarRequest: SideBarTabInterface;
  SpareParts: SideBarTabInterface;
  ShortVideos: SideBarTabInterface;
  Notifications: SideBarTabInterface;
  AppUpdate: SideBarTabInterface;
  DealerMarketplace: SideBarTabInterface;
  QuickCapture: SideBarTabInterface;
  CarImport: SideBarTabInterface;
  Valuations: SideBarTabInterface;
  Distribution: SideBarTabInterface;
}

export const SideBarTabs: SidebarTabsInterface = {
  Overview: {
    name: "Dashboard",
    icon: RxDashboard,
    path: Paths.home,
  },
  Cars: {
    name: "Cars",
    icon: FaCarAlt,
    path: Paths.cars,
  },
  Users: {
    name: "Users",
    icon: FaUser,
    path: Paths.users,
  },
  Messages: {
    name: "Messages",
    icon: FaMessage,
    path: Paths.messages,
  },
  Reports: {
    name: "Reports",
    icon: TbReport,
    path: Paths.reports,
  },
  Staff: {
    name: "Staff",
    icon: FaUserGroup,
    path: Paths.staff,
  },
  MoneyRequest: {
    name: "Money Request",
    icon: FaDollarSign,
    path: Paths.money,
  },
  CarRequest: {
    name: "Car Request",
    icon: FaCarOn,
    path: Paths.carRequest,
  },
  SpareParts: {
    name: "Spare Parts",
    icon: FaTools,
    path: Paths.spareParts,
  },
  ShortVideos: {
    name: "Short Videos",
    icon: FaPlayCircle,
    path: Paths.shortVideos,
  },
  Notifications: {
    name: "Notifications",
    icon: IoNotificationsOutline,
    path: Paths.notifications,
  },
  AppUpdate: {
    name: "App Update",
    icon: IoSettingsOutline,
    path: Paths.appUpdate,
  },
  DealerMarketplace: {
    name: "Dealer Market",
    icon: FaStore,
    path: Paths.dealerMarketplace,
  },
  QuickCapture: {
    name: "Quick Capture",
    icon: IoCameraOutline,
    path: Paths.quickCapture,
  },
  CarImport: {
    name: "Import Cars",
    icon: IoCloudDownloadOutline,
    path: Paths.carImport,
  },
  Valuations: {
    name: "Valuations",
    icon: IoAnalyticsOutline,
    path: Paths.valuations,
  },
  Distribution: {
    name: "Distribution",
    icon: IoShareSocialOutline,
    path: Paths.distribution,
  },
};
